/* eslint-disable */
export default {
  noResultFoundFor: 'Ei tuloksia haulla',
  foundFromServerHint:
    'Tee haku sovelluksessa {appName} kirjoittamalla\navainsana ja painamalla Enteriä',
  notResultFoundFromServer: 'Tuloksia ei löytynyt',
  loading: 'ladataan...',
} as const;

// @key: @#@"noResultFoundFor"@#@ @source: @#@"No result found for"@#@
// @key: @#@"foundFromServerHint"@#@ @source: @#@"Type keyword and press Enter to search in {appName}"@#@
// @key: @#@"notResultFoundFromServer"@#@ @source: @#@"No results found"@#@
// @key: @#@"loading"@#@ @source: @#@"loading..."@#@
